import Swiper, { Navigation, Pagination, Scrollbar, Mousewheel, EffectFade, Autoplay, Manipulation } from 'swiper'
import Mobile from '../../../modules/mobile/v1/mobile'

Swiper.use([Navigation, Pagination, Scrollbar, Mousewheel, EffectFade, Autoplay, Manipulation])

export default function Carousel(element, swiper_options, options) {
  let self = $(element)
  self.data('carousel', self)
  self.mobile = (options && options.mobileBreakpoint) ? new Mobile(options.mobileBreakpoint - 1) : (($.mlmi != undefined && $.mlmi.mobile != undefined) ? $.mlmi.mobile : new Mobile())
  self.swiper = undefined
  self.options = $.extend(true, {
    mobile: true,
    desktop: true,
    groupItems: {
      slidesPerGroup: {
        mobile: false,
        desktop: false,
      },
      wrapperClass: 'slides-group',
    },
    forceRebuild: false,
    onBeforeInit: undefined,
    onInit: undefined,
    onBeforeKill: undefined,
    onKill: undefined,
    wrapperClass: 'swiper-wrapper',
    slideClass: 'swiper-slide',
  }, options)
  self.wrapper = self.find('.' + self.options.wrapperClass)
  self.slides = self.find('.' + self.options.slideClass)

  self.swiper_options = $.extend({
    threshold: 15,
    resistanceRatio: 0.25,
  }, swiper_options)

  self.swiper_next = function() {
    self.swiper.slideNext()
  }

  self.initialize = function() {
    if (self.options.onBeforeInit != undefined) {
      self.options.onBeforeInit(self)
    }
    if ('Carousel_CoreBeforeInit' in window) {
      window.Carousel_CoreBeforeInit(self)
    }
    self.addClass('swiper-container')
    self.wrapper.addClass('swiper-wrapper')
    self.slides.addClass('swiper-slide')
    if (self.options.groupItems && self.getSlidesPerGroup()) {
      if (self.getSlidesPerGroup() == 'auto') {
        let group_columns = [], group_columns_total = 0
        self.find('.' + self.options.wrapperClass + ' > .' + self.options.slideClass).each(function() {
          let current_column = $(this),
            current_column_width = parseInt(current_column.attr('data-cols'), 10)
          group_columns_total += current_column_width
          if (group_columns_total > 12) {
            $(group_columns).removeClass('swiper-slide').wrapAll($('<div class="' + self.options.groupItems.wrapperClass + '">'))
            group_columns = []
            group_columns_total = current_column_width
          }
          group_columns.push(current_column.get(0))
          if (current_column.is(':last-child') || group_columns_total == 12) {
            $(group_columns).removeClass('swiper-slide').wrapAll($('<div class="' + self.options.groupItems.wrapperClass + '">'))
            group_columns = []
            group_columns_total = 0
          }
        })
      } else {
        while (self.find('.' + self.options.wrapperClass + ' > .' + self.options.slideClass).length > 0) {
          self.find('.' + self.options.wrapperClass + ' > .' + self.options.slideClass + ':lt(' + self.getSlidesPerGroup() + ')').removeClass('swiper-slide').wrapAll($('<div class="' + self.options.groupItems.wrapperClass + '">'))
        }
      }
      $('.' + self.options.groupItems.wrapperClass).addClass('swiper-slide')
    }
    self.swiper = new Swiper(element, self.swiper_options)
    if (self.options.onInit != undefined) {
      self.options.onInit(self)
    }
  }

  self.maybe_initialize = function() {
    if (self.swiper == undefined && ((self.options.desktop && !self.mobile.isMobile) || (self.options.mobile && self.mobile.isMobile))) {
      self.initialize()
    }
  }

  self.kill = function(kill_mobile) {
    if (self.options.onBeforeKill != undefined) {
      self.options.onBeforeKill(self)
    }
    if (kill_mobile == undefined) {
      kill_mobile = false
    }
    self.removeClass('swiper-container')
    if (self.wrapper.length) {
      self.wrapper.removeClass('swiper-wrapper')
    }
    if (self.slides.length) {
      self.slides.removeClass('swiper-slide swiper-slide-duplicate-prev swiper-slide-duplicate-next swiper-slide-duplicate-active')
    }
    if (self.swiper != undefined) {
      self.swiper.destroy()
      self.swiper = undefined
    }
    if (self.options.groupItems) {
      if (self.find('.' + self.options.groupItems.wrapperClass).length) {
        self.slides.unwrap('.' + self.options.groupItems.wrapperClass)
      }
    }
    if (self.options.onKill != undefined) {
      self.options.onKill(self)
    }
    if (kill_mobile) {
      self.mobile.kill()
    }
  }

  self.toggle_mobile = function() {
    self.wrapper.css('height', '')
    if (self.swiper != undefined && self.options.forceRebuild) {
      self.kill()
    }
    if (self.swiper == undefined && self.options.mobile) {
      self.initialize()
    } else if (!self.options.mobile) {
      self.kill()
    }
  }

  self.toggle_desktop = function() {
    self.wrapper.css('height', '')
    if (self.swiper != undefined && self.options.forceRebuild) {
      self.kill()
    }
    if (self.swiper == undefined && self.options.desktop) {
      self.initialize()
    } else if (!self.options.desktop) {
      self.kill()
    }
  }

  self.getSlidesPerGroup = function() {
    if (self.options.groupItems && self.options.groupItems.slidesPerGroup) {
      if (typeof self.options.groupItems.slidesPerGroup === 'number') {
        return self.options.groupItems.slidesPerGroup
      } else if (self.mobile.isMobile) {
        return self.options.groupItems.slidesPerGroup.mobile ? self.options.groupItems.slidesPerGroup.mobile : false
      } else {
        return self.options.groupItems.slidesPerGroup.desktop ? self.options.groupItems.slidesPerGroup.desktop : false
      }
    }
    return false
  }

  self.init = function() {
    if (self.slides.length > 1) {
      self.mobile.addCallbacks(self.toggle_mobile, self.toggle_desktop)
    }
  }

  return self
}

export function getCarouselGutterWidth(carousel, size) {
  let gutterSizerClass = size == undefined ? 'carousel-gutter-sizer' : 'carousel-gutter-sizer carousel-gutter-sizer-' + size,
    gutterSizer = $('<div>').addClass(gutterSizerClass).appendTo(carousel),
    gutterSize = gutterSizer.outerWidth(false)
  gutterSizer.remove()
  return gutterSize
}

export function Carousel_CoreInit(custom_parameters = [], scope) {
  if (scope == undefined) {
    scope = document
  }
  $(scope).find('.carousel').each(function() {
    let self = $(this)
    let coreOptions = self.data('carousel'),
      heightOptions = self.data('height'),
      autoPlayDelay = self.data('autoplay'),
      slidesPerView = self.data('columns'),
      swiperOptions = {
        direction: 'horizontal',
        loop: $.inArray('loop', coreOptions) !== -1 ? true : false,
        simulateTouch: $.inArray('simulate_touch', coreOptions) !== -1 ? true : false,
        speed: self.data('speed'),
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: getCarouselGutterWidth(self, 'sm'),
          },
          768: {
            slidesPerView: slidesPerView,
            spaceBetween: getCarouselGutterWidth(self, 'md'),
          }
        }
      }
    if ($.inArray('use_bullets', coreOptions) !== -1) {
      swiperOptions.pagination = {
        el: self.find('.carousel__toolbar .swiper-pagination').get(0),
        type: 'bullets',
        clickable: true,
      }
    }
    if ($.inArray('use_arrows', coreOptions) !== -1) {
      swiperOptions.navigation = {
        prevEl: self.find('.carousel__toolbar .swiper-button-prev').get(0),
        nextEl: self.find('.carousel__toolbar .swiper-button-next').get(0),
      }
    }
    if ($.inArray('use_fraction', coreOptions) !== -1) {
      swiperOptions.pagination = {
        el: self.find('.carousel__toolbar .swiper-pagination').get(0),
        type: 'fraction',
        clickable: true,
      }
    }
    if ($.inArray('use_scrollbar', coreOptions) !== -1) {
      swiperOptions.loop = false
      swiperOptions.scrollbar = {
        el: self.find('.carousel__toolbar .swiper-scrollbar').get(0),
        draggable: true,
      }
    }
    if (heightOptions == 'auto-height') {
      swiperOptions.autoHeight = true
    } else if (heightOptions == 'auto-height-sm') {
      swiperOptions.breakpoints[0].autoHeight = true
      swiperOptions.breakpoints[768].autoHeight = false
    } else if (heightOptions == 'auto-height-md') {
      swiperOptions.breakpoints[0].autoHeight = false
      swiperOptions.breakpoints[768].autoHeight = true
    }
    if (autoPlayDelay != undefined && parseFloat(autoPlayDelay) > 0) {
      swiperOptions.autoplay = {
        delay: Math.round(autoPlayDelay * 1000),
        disableOnInteraction: true,
      }
    }
    if ($.inArray('group_slides', coreOptions) !== -1) {
      swiperOptions.breakpoints[768].slidesPerGroup = slidesPerView
      swiperOptions.breakpoints[768].loopFillGroupWithBlank = true
    }
    let carouselOptions = {
      mobile: self.data('carousel-sm') || self.data('carousel-lg') ? true : false,
      desktop: self.data('carousel-md') ? true : false,
      mobileBreakpoint: self.data('carousel-lg') ? 1024 : undefined,
      wrapperClass: 'carousel__wrapper',
      slideClass: 'carousel__slide',
      forceRebuild: true,
    }

    custom_parameters.forEach(function(item) {
      if (!item.classSelector || self.hasClass(item.classSelector) || self.closest('.carousel__container').hasClass(item.classSelector)) {
        swiperOptions = $.extend(true, swiperOptions, item.swiperOptions)
        carouselOptions = $.extend(true, carouselOptions, item.carouselOptions)
      }
    })
    let carousel = new Carousel(self.get(0), swiperOptions, carouselOptions)
    carousel.init()
  })
}
